import { apiSlice } from "../api/apiSlice";
import { assignmentsApi } from "@features/assignments/assignmentsApi";

export const videosApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getVideos: builder.query({
      query: () => "/videos",
    }),
    getVideo: builder.query({
      query: (id) => `/videos/${id}`,
    }),
    addVideo: builder.mutation({
      query: (data) => ({
        url: "/videos",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const video = await queryFulfilled;
          // add video cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              draft.push(video?.data);
            })
          );
          // add video cache pessimistically end
        } catch (err) {}
      },
    }),
    updateVideo: builder.mutation({
      query: ({ id, data }) => ({
        url: `/videos/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const video = await queryFulfilled;

          // add videos cache pessimistically start
          dispatch(
            apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
              const indexToUpdate = draft.find((v) => v.id == arg.id);
              indexToUpdate.title = video?.data?.title;
              indexToUpdate.description = video?.data?.description;
              indexToUpdate.url = video?.data?.url;
              indexToUpdate.views = video?.data?.views;
              indexToUpdate.duration = video?.data?.duration;
              indexToUpdate.createdAt = video?.data?.createdAt;
            })
          );
          // add videos cache pessimistically end

          // Update the video title in the assignment's table
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                draft.forEach((assignment) => {
                  if (assignment.video_id == arg.id) {
                    assignment.video_title = video?.data?.title;
                  }
                });
              }
            )
          );

          // Update the video title in the quizzes table
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              draft.forEach((quiz) => {
                if (quiz.video_id == arg.id) {
                  quiz.video_title = video?.data?.title;
                }
              });
            })
          );
        } catch (err) {}
      },
    }),
    deleteVideo: builder.mutation({
      query: (id) => ({
        url: `/videos/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(id, { queryFulfilled, dispatch }) {
        // optimistic cache update start
        const pathResult = dispatch(
          apiSlice.util.updateQueryData("getVideos", undefined, (draft) => {
            const indexToRemove = draft.findIndex((v) => v.id === id);
            if (indexToRemove !== -1) {
              draft.splice(indexToRemove, 1);
            }
          })
        );
        // optimistic cache update end

        try {
          await queryFulfilled;

          // Remove the assignment object corresponding to this video
          dispatch(
            apiSlice.util.updateQueryData(
              "getAssignments",
              undefined,
              (draft) => {
                draft.filter((assignment) => assignment.id !== id);
                console.log(JSON.stringify(draft));
              }
            )
          );

          // Remove the quiz object corresponding to this video
          dispatch(
            apiSlice.util.updateQueryData("getQuizzes", undefined, (draft) => {
              draft.filter((quiz) => quiz.id !== id);
              console.log(JSON.stringify(draft));
            })
          );
        } catch (err) {
          pathResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetVideosQuery,
  useGetVideoQuery,
  useAddVideoMutation,
  useUpdateVideoMutation,
  useDeleteVideoMutation,
} = videosApi;
